import React from "react";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import ConsultationAreaTwo from "../../components/Consultation/ConsultationAreaTwo";
import HistoryArea from "../../components/HistoryArea/HistoryArea";
import SuccessArea from "../../components/SuccessArea/SuccessArea";
import TestimonialArea from "../../components/Testimonial/TestimonialArea";
import Layout from "../../layouts/Layout";
import { Helmet } from "react-helmet";

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>About Us – The Digital Creative Designs USA</title>
        <meta
          name="description"
          content="The Digital Creative Designs delivers innovative graphic design solutions that elevate your brand. Discover how our expert team can bring your vision to life. Contact us today!"
        />
        <meta name="robots" content="noindex,nofollow" />
        <meta name="author" content="The Digital Creative Designs" />
        <meta
          property="og:title"
          content="About Us – The Digital Creative Designs USA"
        />
        <meta
          property="og:description"
          content="The Digital Creative Designs delivers innovative graphic design solutions that elevate your brand. Discover how our expert team can bring your vision to life. Contact us today!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="The Digital Creative Designs US" />
        <meta
          property="og:url"
          content="https://thedigitalcreativedesigns.com/about-us"
        />
        <meta
          property="og:image"
          content="https://thedigitalcreativedesigns.com/img/logo1.png"
        />

        <link rel="canonical" href="https://thedigitalcreativedesigns.com/about-us" />
      </Helmet>

      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title="About Us"
          subtitle={"About Us"}
          className={"pt-175 pb-60"}
        />
        <ConsultationAreaTwo />
        <SuccessArea />
        <HistoryArea />
        <TestimonialArea />
      </Layout>
    </>
  );
};

export default AboutUs;
